{
  "version": 1,
  "asset_id": "a50c4d55-30fd-4b35-8331-ab295ff5ca3a",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/a50c4d55-30fd-4b35-8331-ab295ff5ca3a/hiatal-normal-es-v3-1200.jpg",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/a50c4d55-30fd-4b35-8331-ab295ff5ca3a/hiatal-normal-es-v3-1200.jpg",
  "original_filename": "hiatal-normal-es-v3-1200.jpg",
  "size": 224691,
  "content_type": "image/jpeg",
  "created_at": "2026-10-28T23:11:56Z"
}
